import React, { Component } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonItem,
  IonList,
  IonButtons,
  IonButton,
  IonGrid,
  IonCol,
  IonRow,
  IonLabel,
  IonBackButton,
  IonImg,
  IonModal,
  IonSlides,
  IonSlide,
  withIonLifeCycle,
  isPlatform,
  IonPopover,
} from "@ionic/react";

import { RouteComponentProps, withRouter } from "react-router";
import { TransformWrapper, TransformComponent, ReactZoomPanPinchRef } from "react-zoom-pan-pinch";

// CSS
import "./AlgorithmPage.css";
import "../../Shared.css";
import "../../../App.css";

// Images
import iconSearchInactive from "../../assets/Button_Page Search_1 Default@3x.png";
import iconSearchActive from "../../assets/Button_Page Search_2 Active@3x.png";
import iconBookmarkActive from "../../assets/Button_Bookmark_2Active@3x.png";
import iconBookmarkInactive from "../../assets/Button_Bookmark_1Inactive@3x.png";

import buttonClose from "../../assets/Button_Close@3x.png";
import iconAccessibility from "../../assets/Button_Accessibility@3x.png";

// Controllers
import { IScreenProps, IUser, IGuideline, IAlgorithm, IGuidelineSummary } from "../../Interfaces";
import AppController from "../../../controllers/AppController";
import RemoteDataController from "../../controllers/RemoteDataController";
import DataController from "../../controllers/DataController";

// Components
import _ from "lodash";
import FontPopover from "../../components/FontPopover";
import ImageViewerModal from "../../components/ImageViewerModal";

type Props = RouteComponentProps<{ id: string; tab: string }> & { screenProps: IScreenProps; features: string[] };
type State = {
  selectedID: string;
  algorithm: IAlgorithm | undefined;
  guideline: IGuideline | undefined | null;
  guidelineSummary: IGuidelineSummary | undefined;
  imageModalVisible: boolean;
  fontModalVisible: boolean;
  fontModalEvent: any;
  imageSrc: any;
};

class AlgorithmPage extends Component<Props, State> {
  private imageModalZoom: React.RefObject<ReactZoomPanPinchRef>;

  constructor(props: Props) {
    super(props);

    this.imageModalZoom = React.createRef();

    let selectedID = "";
    if (props.match.url != null) {
      selectedID = props.match.url.substr(props.match.url.lastIndexOf("/") + 1);
    }
    if (selectedID == null) {
      selectedID = props.match.url.substr(props.match.url.lastIndexOf("/") + 1);
    }

    let algorithm = this.props.screenProps.algorithms.find((_algorithm: any) => _algorithm.id === selectedID);
    let guidelineSummary = props.screenProps.guidelineSummaries.find(
      (guidelineSummary: IGuidelineSummary) => guidelineSummary.GLID === algorithm?.GLID
    );
    if (guidelineSummary == null) {
      guidelineSummary = props.screenProps.algorithmOnlyGuidelineSummaries.find(
        (guidelineSummary: IGuidelineSummary) => guidelineSummary.GLID === algorithm?.GLID
      );
    }

    this.state = {
      selectedID,
      algorithm,
      guideline: null,
      guidelineSummary: guidelineSummary,
      imageModalVisible: false,
      fontModalVisible: false,
      fontModalEvent: null,
      imageSrc: "",
    };
  }

  async componentDidMount() {
    document.addEventListener("click", this.handleClickEvent);

    if (this.state.guidelineSummary != null) {
      let guideline = await DataController.getGuideline(this.state.guidelineSummary);
      this.setState({ guideline });
    }

    if (this.state.algorithm != null && this.props.screenProps.user != null) {
      await this.props.screenProps.saveRecentlyViewed(
        this.state.algorithm.GLID ? this.state.algorithm.GLID : "",
        this.state.algorithm.id,
        null,
        null,
        "algorithm"
      );

      RemoteDataController.logUsage(
        null,
        this.state.algorithm,
        null,
        null,
        null,
        false,
        "",
        this.props.screenProps.user,
        this.props.screenProps.app
      );
      DataController.logLocalUsage(
        null,
        this.state.algorithm,
        null,
        null,
        null,
        null,
        this.props.screenProps.user.email
      );
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickEvent);
  }

  async componentDidUpdate(prevProps: Props, prevState: State) {
    if (
      prevProps.screenProps.guidelineSummaries != this.props.screenProps.guidelineSummaries ||
      prevProps.screenProps.algorithms != this.props.screenProps.algorithms ||
      prevProps.screenProps.algorithmOnlyGuidelineSummaries != this.props.screenProps.algorithmOnlyGuidelineSummaries
    ) {
      let algorithm = this.props.screenProps.algorithms.find((algorithm) => algorithm.id === this.state.selectedID);
      let guidelineSummary = this.props.screenProps.guidelineSummaries.find(
        (guidelineSummary) => guidelineSummary.GLID === algorithm?.GLID
      );
      if (guidelineSummary == null) {
        guidelineSummary = this.props.screenProps.algorithmOnlyGuidelineSummaries.find(
          (guidelineSummary: IGuidelineSummary) => guidelineSummary.GLID === algorithm?.GLID
        );
      }

      let guideline = null;

      if (guidelineSummary != null) {
        guideline = await DataController.getGuideline(guidelineSummary);
      }

      if (algorithm != null) {
        this.setState({ algorithm });
      }

      if (guidelineSummary != null && guideline != null) {
        this.setState({ guidelineSummary, guideline });
      }
    }

    if (this.state.algorithm && this.state.guidelineSummary) {
      let selectedID = "";
      if (this.props.match.url != null) {
        selectedID = this.props.match.url.substr(this.props.match.url.lastIndexOf("/") + 1);
      }
      if (selectedID == null) {
        selectedID = this.props.match.url.substr(this.props.match.url.lastIndexOf("/") + 1);
      }

      let algorithm = this.props.screenProps.algorithms.find((_algorithm: any) => _algorithm.id === selectedID);
      let guidelineSummary = this.props.screenProps.guidelineSummaries.find(
        (guidelineSummary: IGuidelineSummary) => guidelineSummary.GLID === algorithm?.GLID
      );
      if (guidelineSummary == null) {
        guidelineSummary = this.props.screenProps.algorithmOnlyGuidelineSummaries.find(
          (guidelineSummary: IGuidelineSummary) => guidelineSummary.GLID === algorithm?.GLID
        );
      }

      if (algorithm != null && algorithm.id !== this.state.algorithm.id) {
        this.setState({ algorithm });
      }
      if (guidelineSummary != null && guidelineSummary.GLID !== this.state.guidelineSummary.GLID) {
        let guideline = await DataController.getGuideline(this.state.guidelineSummary);
        this.setState({ guidelineSummary, guideline });
      }
    }
  }

  handleClickEvent = (event: any) => {
    if (this.state.algorithm != null) {
      if (event.srcElement.localName === "img") {
        if (event.srcElement.className.includes("algorithmImage") || event.srcElement.className.includes("img11")) {
          if (this.props.match.url === event.currentTarget.location.pathname) {
            RemoteDataController.logEvent("image_modal_clicked", {
              from: "algorithm",
              algorithmID: this.state.algorithm.id,
              algorithm_title: this.state.algorithm.name,
              glid: this.props.screenProps.getGuidelineTitleForLogging(this.state.algorithm.GLID),
            });
            this.toggleImageModal(true, event.srcElement);
          }
        }
      }
      if (event.srcElement.localName === "cm-link") {
        if (this.props.match.url === event.currentTarget.location.pathname) {
          if (event.srcElement && event.srcElement.attributes && event.srcElement.attributes.length > 0) {
            let href = event.srcElement.attributes[0];
            if (href.value != null && href.value.includes("CLID")) {
              let GLID = href.value.substr(5);
              let title = event.srcElement.textContent;

              this.props.screenProps.navigateToGuideline(
                GLID,
                this.props.match.params.tab,
                this.props.history,
                null,
                "Algorithm"
              );
            } else if (event.srcElement.attributes.cnid != null) {
              const cnid = event.srcElement.attributes.cnid.value;
              this.props.screenProps.navigateToClinicalNotice(
                cnid,
                this.props.match.params.tab,
                this.props.history,
                null,
                "Algorithm"
              );
            } else if (href.value != null && href.value.substr(0, 1) === "-") {
              let GLID = href.value;
              let title = event.srcElement.textContent;

              this.props.screenProps.navigateToGuideline(
                GLID,
                this.props.match.params.tab,
                this.props.history,
                null,
                "Algorithm"
              );
            } else if (href.value && href.value.includes("http")) {
              if (!href.value.match(/^https?:\/\//i)) {
                let url = "https://" + href.value;
                window.open(url, "_blank", "noreferrer");
              } else {
                window.open(href.value, "_blank", "noreferrer");
              }
            } else if (href.value && href.value.includes("#")) {
              event.preventDefault();
            } else if (href.value != null) {
              if (!href.value.match(/^https?:\/\//i)) {
                let url = "https://" + href.value;
                window.open(url, "_blank", "noreferrer");
              } else {
                window.open(href.value, "_blank", "noreferrer");
              }
            }
          }
        }
      }
    }
  };

  handleBackEvent = (event: any) => {
    if (this.state.imageModalVisible) {
      this.setState({
        imageModalVisible: false,
      });
    } else if (this.state.fontModalVisible) {
      this.setState({
        fontModalVisible: false,
      });
    } else {
      // console.log(event);
    }
  };

  async navigateToGuideline(algorithm: IAlgorithm) {
    let guideline = this.state.guideline;

    if (algorithm != null && guideline != null) {
      let figure = "";
      let sectionName = "";
      if (algorithm.caption.includes("Figure")) {
        let result = algorithm.caption.match(/Figure (\d+)?\.?(\d+)?/g);
        if (result && result.length > 0) {
          figure = result[0];
        }
      } else if (algorithm.GuideLineSectionTitle) {
        sectionName = algorithm.GuideLineSectionTitle;
      }

      this.props.screenProps.navigateToGuideline(
        guideline.GLID,
        this.props.match.params.tab,
        this.props.history,
        { figure: figure, sectionName: sectionName },
        "Algorithm"
      );
    }
  }

  generateAlgorithm(algorithm: IAlgorithm) {
    let guideline = this.state.guideline;

    let sectionHTML = "";

    // add section HTML if there is any (e.g. Glasgow Coma Scale)
    if (guideline != null && algorithm.GuideLineSectionTitle != null && guideline.sections != null) {
      for (let sectionIndex = 0; sectionIndex < guideline.sections.length; sectionIndex++) {
        let section = guideline.sections[sectionIndex];

        if (section.SectionTitle === algorithm.GuideLineSectionTitle) {
          sectionHTML = section.sectionHTML;
          sectionHTML = this.replaceImages(sectionHTML);
          break;
        }
      }
    }

    let imageSrc = null;
    for (let i = 0; i < this.props.screenProps.images.length; i++) {
      let image = this.props.screenProps.images[i];
      if (algorithm.image === image.name) {
        imageSrc = image.data;
        break;
      }
    }

    let annotationLayout = null;

    let annotations = this.state.algorithm?.annotations;

    if (annotations) {
      let userTrust = this.props.screenProps.trust;

      for (let annotation of annotations) {
        if (annotation["note (html)"]) {
          var aNote = annotation["note (html)"];

          annotationLayout = (
            <div className={`algorithmAnnotation ${userTrust}Note`}>
              <div className={`${userTrust}NoteBox`}>
                <div className={`${userTrust}NoteTitle`}>
                  {DataController.getTrustDisplayName(userTrust)} Additional Guidance
                </div>
                <div className={`trustNoteData ${userTrust}NoteData`}>
                  <div style={{ fontSize: this.fontSize(16) }} dangerouslySetInnerHTML={{ __html: aNote }} />
                </div>
              </div>
            </div>
          );
        }
      }
    }

    let showGoToGuidelineButton = true;
    // hide guideline button if algorithm only guidleline for CFR
    let guidelineSummary = this.props.screenProps.guidelineSummaries.find(
      (guidelineSummary: IGuidelineSummary) => guidelineSummary.GLID === algorithm?.GLID
    );
    if (guidelineSummary == null) {
      showGoToGuidelineButton = false;
    }

    if (isPlatform("mobile") && !isPlatform("tablet")) {
      return (
        <div className="algorithmContainer">
          {annotationLayout}
          {imageSrc != null ? <img alt="" className="algorithmImage algorithmImageMobile" src={imageSrc} /> : null}
          <div>
            <div
              style={{ fontSize: this.fontSize(16) }}
              className="algorithmFigure algorithmFigureMobile"
              dangerouslySetInnerHTML={{ __html: algorithm.caption }}
            />
          </div>
          {guideline != null && showGoToGuidelineButton ? (
            <div
              className="viewGuidelineButton viewGuidelineButtonMobile"
              onClick={() => {
                RemoteDataController.logEvent("guideline_clicked", {
                  from: "algorithm",
                  algorithmID: algorithm.id,
                  algorithm_title: algorithm.name,
                  glid: this.props.screenProps.getGuidelineTitleForLogging(algorithm.GLID),
                });
                this.navigateToGuideline(algorithm);
              }}
            >
              <span className="viewGuidelineText">
                {DataController.isDrug(guideline) ? "Go to Med" : "Go to Guideline"}
              </span>
            </div>
          ) : null}
          <div className="algorithmSection" dangerouslySetInnerHTML={{ __html: sectionHTML }}></div>
        </div>
      );
    }

    return (
      <div className="algorithmContainer">
        <IonRow>
          {annotationLayout}
          {imageSrc != null ? (
            <div className="algorithmImageContatiner">
              <img alt="" className="algorithmImage" src={imageSrc} />
            </div>
          ) : null}
          <div>
            <div>
              <div
                style={{ fontSize: this.fontSize(16) }}
                className="algorithmFigure"
                dangerouslySetInnerHTML={{ __html: algorithm.caption }}
              />
            </div>
            {guideline != null && showGoToGuidelineButton ? (
              <div
                className="viewGuidelineButton"
                onClick={() => {
                  RemoteDataController.logEvent("guideline_clicked", {
                    from: "algorithm",
                    algorithmID: algorithm.id,
                    algorithm_title: algorithm.name,
                    glid: this.props.screenProps.getGuidelineTitleForLogging(algorithm.GLID),
                  });
                  this.navigateToGuideline(algorithm);
                }}
              >
                <span className="viewGuidelineText">
                  {DataController.isDrug(guideline) ? "Go to Med" : "Go to Guideline"}
                </span>
              </div>
            ) : null}
            <div
              className="algorithmSection"
              style={{ fontSize: this.fontSize(16) }}
              dangerouslySetInnerHTML={{ __html: sectionHTML }}
            ></div>
          </div>
        </IonRow>
      </div>
    );
  }

  bookmarkButtonPressed() {
    if (this.state.algorithm != null) {
      this.props.screenProps.saveBookmark(
        this.state.algorithm.GLID ? this.state.algorithm.GLID : "",
        this.state.algorithm.id,
        null,
        null,
        "algorithm"
      );
    }
  }

  isBookmarked() {
    if (this.state.algorithm) {
      let bookmark = _.find(this.props.screenProps.bookmarks, {
        algorithmID: this.state.algorithm.id,
        type: "algorithm",
      });
      return bookmark != null;
    } else {
      return false;
    }
  }

  toggleFontModal(value: boolean, event: any) {
    this.setState({
      fontModalVisible: value,
      fontModalEvent: event,
    });
    if (value === true) {
      RemoteDataController.logEvent("accessability_popover_opened", {
        from: "algorithm",
      });
    }
  }

  toggleImageModal(value: boolean, srcElement?: any) {
    this.props.screenProps.showStatusBar(value, "#008477");

    if (srcElement) {
      let html = srcElement.outerHTML
        .replace('class="algorithmImage"', "")
        .replace('class="algorithmImage algorithmImageMobile"', "");

      this.setState({
        imageSrc: html,
        imageModalVisible: value,
      });
    } else {
      this.setState({
        imageModalVisible: value,
      });
    }
  }

  fontSize(size: number) {
    return `${size + this.props.screenProps.fontSizeChange}px`;
  }

  replaceImages(originalHtml: string) {
    let guideline = this.state.guideline;
    if (guideline == null) {
      return originalHtml;
    }

    let html = originalHtml.replace(/src="/g, 'class="img11" src="');
    html = html.replace(/\.png/g, ".jpg");
    html = html.replace(/GLImage/g, "GLimage");

    // replace image paths
    let matches: any[] | null = [];
    let imageUrls = [];
    let imageRegex = /<img.*?src=['"](.*?)['"]/g;

    try {
      while ((matches = imageRegex.exec(html))) {
        imageUrls.push(matches[1]);
      }

      for (let imageIndex = 0; imageIndex < imageUrls.length; imageIndex++) {
        let imageUrl = imageUrls[imageIndex];
        let bundledImage = DataController.getBundledImageData({
          imageName: imageUrl,
          trust: this.state.guidelineSummary?.trust,
        });
        html = html.replace(`src="${imageUrl}"`, `src="${bundledImage}"`);
      }
    } catch (error) {
      console.log(error);
    }

    // if image is downloaded rather than bundled - try to replace it here
    if (_.findIndex(this.props.screenProps.images, (_image: any) => _image.name.includes(guideline?.GLID)) !== -1) {
      let images = this.props.screenProps.images.filter((_image: any) => _image.name.includes(guideline?.GLID));

      for (let i = 0; i < images.length; i++) {
        let image = images[i];
        html = html.replace(`src="${image.name}"`, `src="${image.data}"`);
      }
    }
    return html;
  }

  render() {
    let algorithm = this.state.algorithm;
    let guideline = this.state.guideline;

    if (algorithm == null) {
      let messageText = "Algorithm is loading";

      if (this.props.screenProps.messageBarText === "") {
        messageText = "Algorithm couldn't be loaded. It might not exist or has been removed.";
      }

      return (
        <IonPage>
          <IonHeader>
            <IonToolbar mode="ios" className="navBar">
              <IonButtons slot="start" className="headerButtonText" color="#FFFFFF">
                <IonBackButton defaultHref={`/${this.props.match.params.tab}`} class="headerButtonText" />
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <div className="emptyPageContainer">
              <div className="emptyPageText">{messageText}</div>
            </div>
          </IonContent>
        </IonPage>
      );
    }

    let content = null;
    let title = algorithm ? algorithm.name : "";

    content = this.generateAlgorithm(algorithm);
    const isBookmarked = this.isBookmarked();

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar mode="ios" className="navBar">
            <IonButtons slot="start" className="headerButtonText" color="#FFFFFF">
              <IonBackButton defaultHref={`/${this.props.match.params.tab}`} class="headerButtonText" />
            </IonButtons>
            <IonButtons slot="end">
              <IonButton className="headerButtons" onClick={(event) => this.toggleFontModal(true, event)}>
                <IonImg src={iconAccessibility} />
              </IonButton>
              {guideline && guideline.GLID !== "GAUTH" ? (
                <IonButton className="headerButtons" onClick={() => this.bookmarkButtonPressed()}>
                  <IonImg src={isBookmarked ? iconBookmarkActive : iconBookmarkInactive} />
                </IonButton>
              ) : null}
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent color="#EDEEF0" id={`${this.props.match.params.tab}-guideline-content`}>
          <div className="ACCEGuidelineTitle algorithms" style={{ fontSize: this.fontSize(21) }}>
            <div className="globalContentMargin">{title}</div>
          </div>

          {this.props.features.includes("algorithmsInfoOnlyNotices") ? (
            <div>
              <div className="warningContainer" style={{ flexDirection: "column-reverse" }}>
                <div
                  style={{
                    fontSize: this.fontSize(14),
                    lineHeight: this.fontSize(14) + 6,
                  }}
                  className="warningText globalContentMargin"
                >
                  {"Algorithms are provided for information purposes only. Responders " +
                    "must practise according to the local policies of your organisation."}
                </div>
              </div>
            </div>
          ) : null}

          <div className="globalContentMargin">
            <div>
              <div className="AACEQuickLookTitle">{"VISUAL GUIDE"}</div>
              <hr aria-hidden="true" className="AACENoMargin" />
            </div>
            {content}
          </div>
          {window.innerWidth < 600 ? (
            <IonModal
              mode="ios"
              id="fontModal2"
              showBackdrop={true}
              isOpen={this.state.fontModalVisible}
              initialBreakpoint={1}
              breakpoints={[0, 1]}
              // event={this.state.fontModalEvent}
              backdropDismiss={true}
              onDidDismiss={() => this.toggleFontModal(false, null)}
            >
              <div className="triangle" />
              <FontPopover features={this.props.features} screenProps={this.props.screenProps} />
            </IonModal>
          ) : (
            <IonPopover
              mode="ios"
              id="fontModal"
              showBackdrop={false}
              isOpen={this.state.fontModalVisible}
              event={this.state.fontModalEvent}
              backdropDismiss={true}
              onDidDismiss={() => this.toggleFontModal(false, null)}
            >
              <div className="triangle" />
              <FontPopover features={this.props.features} screenProps={this.props.screenProps} />
            </IonPopover>
          )}
          <ImageViewerModal
            isOpen={this.state.imageModalVisible}
            isBookmarked={isBookmarked}
            isReferenceCard={false}
            imageSrc={this.state.imageSrc}
            toggleImageModal={this.toggleImageModal.bind(this)}
            bookmarkButtonPressed={this.bookmarkButtonPressed.bind(this)}
            tab={this.props.match.params.tab}
          />
        </IonContent>
      </IonPage>
    );
  }
}

export default withRouter(withIonLifeCycle(AlgorithmPage));
